<template>
  <div>
    <!-- empty Data component -->
    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>

    <!-- 연장근무보상시간 리스트 -->
    <v-list v-else flat class="leave-list">
      <v-list-item-group v-for="(item, i) in searchList" :key="i">
        <v-list-item
          :ripple="false"
          class="d-block py-5"
          :class="item.useFlag ? '' : 'item-none'"
        >
          <dl class="d-flex justify-space-between">
            <dt class="label">근무월</dt>
            <dd class="desc ml-auto">{{ item.ym }}</dd>
          </dl>
          <dl class="d-flex justify-space-between">
            <dt class="label">사용가능기간</dt>
            <dd class="desc ml-auto">{{ item.useTerm }}</dd>
          </dl>
          <dl class="d-flex justify-space-between">
            <dt class="label">보상시간</dt>
            <dd class="desc ml-auto">
              <span>{{ item.rewTime }}</span>
              <span class="unit">시간</span>
            </dd>
          </dl>
          <dl class="d-flex justify-space-between">
            <dt class="label">잔여시간</dt>
            <dd class="desc ml-auto point-blue">
              <span class="point-blue">{{ item.restTime }}</span>
              <span class="unit">시간</span>
            </dd>
          </dl>
          <div class="d-flex flex-row-reverse chips-wrap">
            <v-chip v-if="item.useFlag" label class="blue">사용가능</v-chip>
            <v-chip v-else label class="red">사용불가능</v-chip>
          </div>
        </v-list-item>
        <v-divider inset class="list-divider-line"></v-divider>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
/* 연장근무보상시간 리스트 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
import { getWorkOverRewardList } from '@/api/workStatus';
import { getDateTerm, getDateYm } from '@/utils/common/dateUtil';
import messageConstants from '@/const/messageConstants.js';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export default {
  props: {
    searchParam: {
      type: String,
    },
  },
  data: () => ({
    emptyDataFlag: false, // 조회결과없음 플래그
    searchList: [],
    emptyDataText: messageConstants.emptyDataMsg_1,
  }),
  watch: {
    searchParam() {
      this.fetchWorkOverRewardList();
    },
  },
  computed: {
    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
  },
  methods: {
    /* 연장근무보상내역조회  */
    async fetchWorkOverRewardList() {
      try {
        const response = await getWorkOverRewardList({
          searchSabun: this.GET_USER_DATA.ssnSabun,
          searchYear: this.searchParam,
        });
        const dataList = response.data.data;

        this.searchList = [];

        if (dataList.length > 0) {
          dataList.forEach(data => {
            this.searchList.push({
              useTerm: getDateTerm(data.useSYmd, data.useEYmd, 'period'),
              rewTime: data.rewTime != null ? data.rewTime.toFixed(1) : 0,
              restTime: data.restTime != null ? data.restTime.toFixed(1) : 0,
              ym: getDateYm(data.ym),
              useFlag: dayjs().isBetween(
                data.useSYmd,
                data.useEYmd,
                'day',
                '[]',
              )
                ? true
                : false,
            });
          });
        }

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },
  created() {
    this.fetchWorkOverRewardList();
  },
  components: {
    EmptyData,
  },
};
</script>

<style></style>
